/**
 * file_name.js
 *
 * @경로 :
 * @목적 :
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import B_Util   from 'canvas/base/dev/util/B_Util';
import B_Child  from 'canvas/base/dev/child/base/B_Child';

const B_Unreal = (function(){

    const $ = { _isExist : null };

	class B_Unreal extends B_Child {

		constructor(obj) {
		    super(obj);

		    this._isExist = false; // 존재
		}

	}

	B_Util.manageGetAndSet(B_Unreal, $);
	return B_Unreal;
}());

export default B_Unreal;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/base/B_Unreal.js